@if (progressValue>=0) {
  <div class="progress">
    <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100"
      [style.width]="progressValue+'%'">
    </div>
    <span class="sr-only">{{progressValue}}%</span>
  </div>
}

